import { makeLoadable } from '../../LoadableWrapper';
const AsyncPricingBreakdownModal = makeLoadable({
  loader: () => import( /* webpackChunkName: "pop-pricing-breakdown-modal" */'./PricingBreakdownModal')
});
export default AsyncPricingBreakdownModal;